import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ContentfulCardComponent } from "../components/contentful-card/contentful-card.component";
import { ContentfulListItemComponent } from "../components/contentful-list-item/contentful-list-item.component";
import { ContentfulWrapperComponent } from "../components/contentful-wrapper/container/contentful-wrapper.component";
import { CardNewsDetailsComponent } from "./components/card-news-details/card-news-details.component";
import { NewsComponent } from "./container/news.component";

@NgModule({
  declarations: [NewsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ContentfulWrapperComponent,
    ContentfulListItemComponent,
    ContentfulCardComponent,
    CardNewsDetailsComponent
  ]
})
export class NewsModule {}
